import { ContactMenu } from "./ContactMenu";

export const StickyCTA = () => (
  <div
    data-testid="sticky-cta"
    className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 md:hidden"
  >
    <ContactMenu
      type="call"
      label="Chiama"
      testid="sticky-call"
      up
      fullWidth
      wrapperClassName="w-full"
      className="flex w-full items-center justify-center gap-2 bg-[#ff3300] py-4 font-mono text-xs uppercase tracking-[0.16em] text-black"
    />
    <ContactMenu
      type="whatsapp"
      label="WhatsApp"
      testid="sticky-whatsapp"
      up
      fullWidth
      wrapperClassName="w-full"
      className="flex w-full items-center justify-center gap-2 bg-[#25d366] py-4 font-mono text-xs uppercase tracking-[0.16em] text-black"
    />
  </div>
);
